export default {
  setCollectCity(state, city) {
    state.collectCity = city
  },
  setSupportCollectCityList(state, cityList) {
    state.supportCollectCityList = cityList || []
  },
  setCollectInfo(state, info) {
    state.collectInfo = info
  },
  setCollectSkuInfo(state, sku) {
    state.collectSkuInfo = sku
  },
  setCollectStore(state, store) {
    state.collectStore = store
  }
}
